// extracted by mini-css-extract-plugin
export default {"top":"Dashboard_top__xlEgc","title":"Dashboard_title__S67UU","description":"Dashboard_description__di+Bw","content":"Dashboard_content__eAg1L"};